<template>
  <div>
    <div
      v-if="campaign.special_videointroduction?.length || bigTrip"
      class="mt-12 pb-4"
    >
      <template
        v-if="campaign.special_videointroduction?.length"
      >
        <LazyMediaLogoCard
          v-for="(videoIntroduction, idx) in specialVideoIntroductions"
          :key="idx"
          :logo="videoIntroduction.logo"
          :title="videoIntroduction.quote"
          :title-by="videoIntroduction.quote_by"
          :text="videoIntroduction.text"
          :media="videoIntroduction.media"
        />
      </template>

      <LazyCategoryBigTripCard
        v-else-if="bigTrip"
        :trip="bigTrip"
      />
    </div>

    <div id="campaignActionBtnScrollToElement">
      <CategoryCards
        class="mt-12"
        :list="list"
        :loading="false"
      />
      <h4
        v-if="list.length === 0"
        class="text-center py-12 text-slate-500 font-normal print-hidden mt-12"
      >
        <span data-i18n="categoryCurrentlyEmpty">
          {{ $t('categoryCurrentlyEmpty') }}
        </span>
        <span class="ml-2">
          {{ campaign.topic }}
        </span>
      </h4>
    </div>
  </div>
</template>

<script>
export default defineNuxtComponent({
  props: {
    campaign: {
      type: Object,
      required: true,
    },

    bigTrip: {
      type: Object,
      default: null,
    },
  },

  computed: {
    list () {
      return [
        ...(this.campaign.triptypes || []),
        ...(this.campaign.destinations || []),
      ]
    },

    specialVideoIntroductions () {
      return this.campaign?.special_videointroduction?.map(videoIntroduction => ({
        ...videoIntroduction,
        logo: {
          url: videoIntroduction.cloudinary_logo,
        },
        media: {
          mediatype: 'video',
          type: videoIntroduction.movie_type,
          location: videoIntroduction.movie_id,
          customThumbnail: {
            url: videoIntroduction.cloudinary_image,
          },
        },
      }))
    },
  },
})
</script>
